import React from "react";
import Loader from 'react-loader-spinner';

export const DataTableLoading = () => {
  return (
    <div className="modal loading-popup">
      <Loader type="TailSpin" color="#007c34" height="100" width="100" />
    </div>
  );
}
